module.exports = __webpack_public_path__ + "static/live-chat-mobile-37858ccd7cffab58aa7b301070d6208e.jpg";